import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  "data-testid": "list-b2c-imports-page",
  class: "page list-b2c-imports-page"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex align-center justify-center pt-5 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_AppUploader = _resolveComponent("AppUploader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_layout, { class: "mt-4 pa-0" }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"align-self":"center"} }, [
              _createElementVNode("h2", { class: "section-title" }, [
                _createElementVNode("span", null, "ALL Imports")
              ])
            ], -1)),
            _createVNode(_component_v_layout, {
              "align-end": "",
              class: "py-2 justify-end"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showUploadDialog = true))
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("span", null, "Upload Users Information", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_dialog, {
                  modelValue: _ctx.showUploadDialog,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showUploadDialog) = $event)),
                  "max-width": "600px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, { "grid-list-md": "" }, {
                          default: _withCtx(() => [
                            (!_ctx.addingScore)
                              ? (_openBlock(), _createBlock(_component_v_layout, {
                                  key: 0,
                                  "data-testid": "Upload-Container",
                                  wrap: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: 12,
                                          class: "text-center mt-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_AppUploader, {
                                              "data-testid": "FileUpload",
                                              onAppUploader: _ctx.handleFile,
                                              disabled: _ctx.addingScore,
                                              fileType: "*"
                                            }, null, 8, ["onAppUploader", "disabled"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_actions, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _ctx.startUpload,
                              loading: _ctx.addingScore,
                              variant: "flat"
                            }, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode(" Upload ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["onClick", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.fetchingImports || _ctx.imports)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                (_ctx.imports && _ctx.imports.length)
                  ? (_openBlock(), _createBlock(_component_AppTable, {
                      key: 0,
                      "table-data": _ctx.tableData,
                      loading: _ctx.fetchingImports,
                      onViewItemClick: _cache[2] || (_cache[2] = (e) => _ctx.showImport(e)),
                      disablePagination: true
                    }, null, 8, ["table-data", "loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.fetchingImports && !_ctx.imports)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "grey"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showImportDetailsDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showImportDetailsDialog) = $event)),
      width: "50%"
    }, {
      default: _withCtx(() => [
        (_ctx.currentImportID.id)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "pa-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentImportID.id) + ". " + _toDisplayString(_ctx.currentImportID.status), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.currentImportID.details), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      loading: _ctx.gettingContributionsData,
                      onClick: _ctx.exportContributionCSV,
                      variant: "flat",
                      color: "green"
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" Download Contributions ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" LOADING... ", -1)
              ]))]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar.model,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.snackbar.model) = $event)),
      color: _ctx.snackbar.color ? _ctx.snackbar.color : '',
      bottom: "",
      timeout: _ctx.snackbar.timeout
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackbar.text), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "color", "timeout"])
  ]))
}